import {getFormMessages, isRegistrationClosedVisible, isTicketed} from '@wix/wix-events-commons-statics'
import {getEvent} from '../../selectors/event'
import {isMemberEventRsvpReady, isMemberRsvpExists} from '../../selectors/member-rsvp'
import {shouldNavigateToForm} from '../../selectors/rsvp'
import {DetailsPageAppProps} from '../app/interfaces'
import {connect} from '../runtime-context/context'
import {RsvpFormOwnProps, RsvpFormRuntimeProps} from './interfaces'
import {RsvpForm as Presentation} from './rsvp-form'

const mapRuntimeToProps = ({
  state,
  actions: {formPageLoaded, navigateToChangeRsvp, navigateToMainPage, scrollToElement},
}: DetailsPageAppProps): RsvpFormRuntimeProps => {
  const event = getEvent(state)

  return {
    closedRegistrationMessage: getFormMessages(event).registrationClosed,
    registrationClosed: isRegistrationClosedVisible(event),
    memberRsvpExists: isMemberRsvpExists(state),
    memberRsvpReady: isMemberEventRsvpReady(state),
    ticketedEvent: isTicketed(event),
    shouldNavigateToForm: shouldNavigateToForm(state),
    formPageLoaded,
    navigateToChangeRsvp,
    navigateToMainPage,
    scrollToElement,
  }
}

export const RsvpForm = connect<RsvpFormOwnProps, RsvpFormRuntimeProps>(mapRuntimeToProps)(Presentation)
